import { motion } from "framer-motion";
import { Play } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

const FILMS = [
  { title: "Genesis G70 · Art of Control", cat: "Brand Film", img: "https://images.unsplash.com/photo-1623346483743-b968a27ed34c?w=1600&q=85" },
  { title: "Porsche 911 · Garage Hymn", cat: "Editorial", img: "https://images.pexels.com/photos/36237587/pexels-photo-36237587.jpeg?w=1600" },
  { title: "Headlights / Hymns", cat: "Photography", img: "https://images.unsplash.com/photo-1578245600656-e8fe67a2b5f7?w=1600&q=85" },
  { title: "Jaguar XKR · Nightline", cat: "Dealership", img: "https://images.unsplash.com/photo-1610374634235-b51ef357f905?w=1600&q=85" },
  { title: "Studio Light, Cold Steel", cat: "Photography", img: "https://images.pexels.com/photos/326259/pexels-photo-326259.jpeg?w=1600" },
  { title: "Vintage / Eternal", cat: "Journal", img: "https://images.pexels.com/photos/36427283/pexels-photo-36427283.jpeg?w=1600" },
];

export default function Films() {
  return (
    <main data-testid="films-page" className="bg-black pt-32 pb-24">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-16">
        <motion.p {...reveal} className="overline mb-6">Portfolio</motion.p>
        <motion.h1 {...reveal} className="font-display text-6xl md:text-8xl text-white leading-[0.95]">
          Films <span className="italic text-[var(--gb-gold)]">/</span> Selected
        </motion.h1>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {FILMS.map((f, i) => (
          <motion.article
            {...reveal}
            key={i}
            data-testid={`film-card-${i}`}
            className="group relative aspect-[16/10] overflow-hidden bg-[#0a0a0a]"
          >
            <img
              src={f.img}
              alt={f.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/20 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-end p-8">
              <p className="overline mb-2">{f.cat}</p>
              <h3 className="font-display text-3xl md:text-4xl text-white">{f.title}</h3>
            </div>
            <div className="absolute top-6 right-6 w-12 h-12 rounded-full border border-white/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <Play size={16} className="text-white ml-0.5" />
            </div>
          </motion.article>
        ))}
      </section>
    </main>
  );
}
